import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Solar_Power from "./solar-power/Solar_Power";
import Power_Progress from "./power-progress/Power_Progress";
import Our_Presence from "./our-presence/Our_Presence";
import Free_Consultation from "./free-consultation/Free_Consultation";
import Consultation_Banner from "./consultation-banner/Consultation_Banner";
import Why_Choose_Us from "../about-us/why_choose_us/Why_Choose_Us";
import Trusted_Communities from "./trusted-communities/Trusted_Communities";
import What_Customer_Say from "./what-customer-say/What_Customer_Say";
import Solar_Insights from "./solar-insights/Solar_Insights";
import HomeBanner from "./home_banner/HomeBanner";
import About_Section from "./about_section/About_Section";
import UltimateEvent from "./solar-power/Solar_Power";
import LatestBlogs from "./latest_blogs/LatestBlogs";
import EventSection from "./event_section/EventSection";
import SafetyCommitment from "./safety_commitment/SafetyCommitment";

function Home() {
  return (
    <>
      {/*---old banner--*/}
      {/* <Banner /> */}
      <HomeBanner />
      <About_Section />

      <UltimateEvent />
      <Why_Choose_Us />
      <LatestBlogs />

      <EventSection />
      <SafetyCommitment />

      {/*---------- old code ----------- */}
      {/* <Power_Progress /> */}
      {/* <Our_Presence /> */}
      {/* <Free_Consultation /> */}
      {/* <Solar_Insights /> */}
      {/* <Consultation_Banner /> */}
      {/* <Trusted_Communities /> */}
      <What_Customer_Say />
    </>
  );
}

export default Home;
